export enum DisableRoles {
  SUPERADMIN = 'Super Admin',
  ADMIN = 'Admin',
  VISITOR = 'Visitor',
  USER = 'User',
  CLIENT_ADMIN = 'Client Admin',
  FAMILY = 'Family',
  FIRE_FIGHTER = 'Fire Fighter',
  SUPERVISOR = 'Supervisor',
}
